/**
 * Pre-compiled es messages for Dialog
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Cerrar diálogo` };
